import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Table from '@tables/table'
import { API } from '@const'
import * as utils from '@utils'
import AnnouncementDialog from '@dialogs/announcement-dialog'

class HomePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'HomePage')
        }
    }

    componentDidMount() {
        this.table.queryData()
    }

    options={
        orderDirection: 'desc'
    }

    columns = [
        {
            field: 'created_at',
            type: 'datetime',
            headerStyle: { width: '15%' },
            searchable: false,
        },
        {
            field: 'title',
            headerStyle: { width: '25%' },
        },
        {
            field: 'content_brief',
            headerStyle: { width: '60%' },
        },
    ]

    render() {
        return (
            <React.Fragment>
                <Table
                    ownerName="HomePage"
                    columns={this.columns}
                    options={this.options}
                    onRef={(ref) => {
                        this.table = ref
                    }}
                    queryDataArgs={{
                        apiPath: API.ANNOUNCEMENT_LIST_ACTIVE,
                    }}
                    materialProps={{
                        onRowClick: (evt, selectedRow) => {
                            this.dialog.OpenDialog(selectedRow)
                        },
                    }}
                />
                <AnnouncementDialog
                    onRef={(ref) => {
                        this.dialog = ref
                    }}
                />
            </React.Fragment>
        )
    }
}

HomePage.propTypes = {
    classes: PropTypes.object,
}

const styles = (_theme) => ({})

export default hoc(styles)(HomePage)
